<template>
    <div>
        <ValidationProvider v-slot="{ dirty }" ref="promo" rules="required">
            <label class="ls-label ls-margin--top" for="promo">
                <span v-if="isInvalid && !dirty" class="ls-label__helper-text ls-color--red"
                    >Invalid Code</span
                >
                <span v-if="isValid && !dirty" class="ls-label__helper-text ls-color--green"
                    >Code Applied</span
                >
                Promo Code
            </label>
            <div class="ls-input__wrapper">
                <input
                    id="promo"
                    v-model="promo"
                    v-ls-track.change="{
                        target: 'promo--input',
                        attachValue: true,
                    }"
                    class="ls-input"
                    maxlength="50"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    :class="{
                        'ls-invalid': isInvalid && !dirty,
                        'valid-promo': isValid && !dirty,
                    }"
                    @keydown.enter.prevent="verifyDealForm"
                />
                <span class="ls-input__button ls-promo--button">
                    <button
                        v-ls-track.click="{
                            target: 'promo--apply-button',
                        }"
                        type="button"
                        :disabled="
                            !promo ||
                            (isInvalid && !dirty) ||
                            (isValid && !dirty) ||
                            deal.loadingStatus.isUpdating
                        "
                        class="apply-button ls-button ls-button--inverse"
                        :class="{ 'apply-button-mobile': !desktop }"
                        @click="verifyDealForm"
                    >
                        Apply
                    </button>
                </span>
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { SCREEN_SIZE__GET_DESKTOP_SCREEN, DEAL__ADD_DEAL } from '@/store/types';

export default {
    data() {
        return {
            promo: '',
            initialCheckMade: false,
        };
    },
    computed: {
        ...mapState(['deal', 'order']),
        ...mapGetters({
            desktop: SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
        isValid() {
            return this.initialCheckMade && this.deal.validDeal.deal_id;
        },
        isInvalid() {
            return this.initialCheckMade && !this.deal.validDeal.deal_id;
        },
    },
    created() {
        this.promo = _.get(this.order, 'deal');
        if (this.promo) {
            this.verifyDealForm();
        }
    },
    methods: {
        ...mapActions({
            addDeal: DEAL__ADD_DEAL,
        }),
        async verifyDealForm() {
            await this.addDeal({ deal: this.promo });
            this.initialCheckMade = true;
            if (this.$refs.promo) {
                this.$refs.promo.reset();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.valid-promo {
    border-color: palette(green);
    box-shadow: 0 0 1px palette(green);
}

.apply-button {
    padding-top: rem(-3);
    padding-bottom: rem(-3);
    background: transparent;
    border-top: 0;
    border-bottom: 0;
    border-right: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.apply-button-mobile {
    width: 125px;
}

.ls-promo--button {
    margin-right: 0;
}
.themed-app {
    .valid-promo {
        border-color: $theme-color-primary;
        box-shadow: 0 0 1px $theme-color-primary;
    }

    .ls-label__helper-text {
        &.ls-color--red {
            color: $theme-color-danger !important;
        }
        &.ls-color--green {
            color: $theme-color-primary !important;
        }
    }
}
</style>
